import { RouteObject, useRoutes } from "react-router-dom";
import AboutUsPage from "./pages/about-us-page/about-us-page";
import MainPage from "./pages/main-page/main-page";
import { paths } from "./routes/paths";
import Layout from "./components/common/layout/layout";
import ContactsPage from "./pages/contacts-page/contacts-page";
import TenderhubPage from "./pages/tenderhub-page/tenderhub-page";
import CasesPage from "./pages/cases-page/cases-page";
import CasePage from "./pages/case-page/case-page";
import CaseYogaDayPage from "./pages/case-yoga-day-page/case-yoga-day-page";
import ServicesPage from "./pages/services-page/services-page";
import "./App.sass";
import NotFoundPage from "./pages/not-found-page/not-found-page";
import SelfEmployedFormPage from "./pages/self-employed-page/self-employed-form-page";
import ServicePage from "./pages/service-page/service-page";
import ShowreelPage from "./pages/showreel-page/showreel-page";

function App() {
  const routes: RouteObject[] = [
    { path: paths.MainPage, element: <MainPage /> },
    { path: paths.AboutUsPage, element: <AboutUsPage /> },
    { path: paths.ContactsPage, element: <ContactsPage /> },
    { path: paths.TenderhubPage, element: <TenderhubPage /> },
    { path: paths.CasesPage, element: <CasesPage /> },
    { path: paths.CasePage, element: <CasePage /> },
    { path: paths.CaseYogaDayPage, element: <CaseYogaDayPage /> },
    { path: paths.ServicesPage, element: <ServicesPage /> },
    { path: paths.SelfEmployedFormPage, element: <SelfEmployedFormPage /> },
    { path: paths.ServicesEventMarketingPage, element: <ServicePage /> },
    { path: paths.ServicesSportMarketingPage, element: <ServicePage /> },
    { path: paths.ServicesConsumerPromoPage, element: <ServicePage /> },
    { path: paths.ShowreelPage, element: <ShowreelPage /> },
    { path: "*", element: <NotFoundPage /> },
  ];

  const page = useRoutes(routes);

  return (
    <div className="App">
      <Layout>{page}</Layout>
    </div>
  );
}

export default App;
